import { prefersReducedMotion } from './utils.js';

/**
 * Initialize GSAP + ScrollTrigger and register global plugin.
 * All scene definitions live here. Sections call window.gsap directly.
 * Loaded as globals (assets/gsap.min.js + assets/ScrollTrigger.min.js).
 */
export function initGSAP() {
  if (typeof window.gsap === 'undefined') {
    console.warn('[KW] GSAP not found — scroll animations disabled.');
    return;
  }

  if (window.ScrollTrigger) {
    window.gsap.registerPlugin(window.ScrollTrigger);
  }

  if (prefersReducedMotion()) return;

  initFadeUpOnEnter();
}

/**
 * Animate all .fade-up-on-enter elements as they enter the viewport.
 * Called once on page load; sections added via ajax should call this again.
 */
export function initFadeUpOnEnter() {
  if (prefersReducedMotion() || !window.gsap || !window.ScrollTrigger) return;

  const targets = document.querySelectorAll('.fade-up-on-enter');
  if (!targets.length) return;

  targets.forEach((el) => {
    window.gsap.fromTo(
      el,
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 88%',
          once: true,
        },
      }
    );
  });
}
